// Func = limiting Scope for this file
var lastScrollTop = 0;

//Parallax Elements
var scrollParallax = []

//booking dates
var start = document.getElementById('arriveInput').value;
var end = document.getElementById('departureInput').value;
var opened = 0 ;

var w=window,
d=document,
e=d.documentElement,
g=d.getElementsByTagName('body')[0],
windowWidth = w.innerWidth||e.clientWidth||g.clientWidth,
windowHeight = w.innerHeight||e.clientHeight||g.clientHeight;

//header image to be window height on homepage
resizeWindow();

function openSubNav(element){
	element.nextElementSibling.classList.add('open');
	let allLi = element.nextElementSibling.getElementsByTagName('li');
	let fullh = 0;
	for(let k=0; k < allLi.length; k++){
		fullh = fullh + allLi[k].clientHeight;
	}
	element.nextElementSibling.style.height = fullh + 'px';
}


(function(){

	//burger menu
	document.getElementById('burgerMenu').addEventListener('click', function(){
		if(this.classList.contains('open')){
			this.classList.remove('open');
			document.getElementById('menuSide').classList.remove('open');
			this.getElementsByClassName('text')[0].innerHTML = 'Menu'
		} else {
			this.classList.add('open');
			this.getElementsByClassName('text')[0].innerHTML = 'Close';
			document.getElementById('menuSide').classList.add('open');
		}
	});



	/*****************************************************
			GET WEATHER INFO FROM API
	/*****************************************************/
	if(!(window.ActiveXObject) && "ActiveXObject" in window){
		//explorer
	} else {
		
		if(document.getElementById('weather-container')){

			let weather_grades = document.getElementById('js-weather-grades');

			fetch('https://api.openweathermap.org/data/2.5/weather?q=New%20York,us&APPID=0ddd1af8b5b1833cedd6da7a90934cce&units=imperial')
			.then(function(response) {
				return response.json();
			})
			.then(function(myJson) {
				weather_grades.innerHTML = parseInt(myJson.main.temp)+'°F';
			});
		}


		//parallax :(
		if(document.getElementsByClassName('parallaxRotation').length > 0){
			
				let parallaxoptions = {
					root : null,
					rootMargin : '0px',
					threshold : 0.1
				}
				function handlerParallax(entries, observer){
					for(let entry of entries){
						if (entry.isIntersecting) {
							parallaxRotation(entry.target)
						}
						else {
							let id_elem = entry.target.getAttribute('target-id')
							window.removeEventListener('scroll', scrollParallax[id_elem])
						}
						
					}
				}
				let allparallax = document.getElementsByClassName('parallaxRotation');
				for(let  j = 0; j < allparallax.length; j++ ){
					let observerP = new IntersectionObserver(handlerParallax, parallaxoptions)
					observerP.observe(allparallax[j]);
				}
			
		}

	}

	

	

	//vanilla JS fancybox
	// if(document.getElementsByClassName('lightbox').length > 0){
	// 	let allLightboxes = document.getElementsByClassName('js-lightboxbtn');
	// 	let allLightboxesLength = allLightboxes.length;

	// 	for(let j = 0; j < allLightboxesLength; j++ ){
	// 		allLightboxes[j].addEventListener('click', function(e){
	// 			e.preventDefault();
	// 			//console.log('ugh');
	// 			let currentTarget = this.getAttribute('href').split('#')[1];
	// 			if(!document.getElementById(currentTarget).classList.contains('open')){
	// 				document.getElementById(currentTarget).classList.add('open')
	// 			} else {
	// 				document.getElementById(currentTarget).classList.remove('open')
	// 			}
	// 		});
	// 	}

	// 	let allLightcloses = document.getElementsByClassName('js-lightboxclose');
	// 	let allLightclosesLength = allLightcloses.length;

	// 	for(let j = 0; j < allLightclosesLength; j++ ){
	// 		allLightcloses[j].addEventListener('click', function(e){
	// 			e.preventDefault();
	// 			let currentTarget = this.parentElement.parentElement.id;
	// 			if(!document.getElementById(currentTarget).classList.contains('open')){
	// 				document.getElementById(currentTarget).classList.add('open')
	// 			} else {
	// 				document.getElementById(currentTarget).classList.remove('open')
	// 			}
	// 		});
	// 	}

	// 	//outside click
	// 	// let alllightbox = document.getElementsByClassName('lightbox');
	// 	// let alllightLength = alllightbox.length;
	// 	// for(let j = 0; j < alllightLength; j++ ){
	// 	// 	alllightbox[j].addEventListener('click', function(e){
	// 	// 		//console.log(e.target);
	// 	// 		if(!e.target.classList.contains('slick-arrow')){
	// 	// 			if(this.classList.contains('open')){
	// 	// 				this.classList.remove('open')
	// 	// 			}
	// 	// 		}
				
	// 	// 	});
	// 	// }
	// }

	//booking controls
	let bookingFields = document.getElementsByClassName('js-booking-field');
	for(let i = 0; i < bookingFields.length; i++){
		bookingFields[i].getElementsByClassName('add')[0].addEventListener('click', function(){
			addNumber(bookingFields[i])
		})
		bookingFields[i].getElementsByClassName('remove')[0].addEventListener('click', function(){
			removeNumber(bookingFields[i])
		})
	}
	document.getElementsByClassName('js-booking-submit')[0].addEventListener('click', function(){
		document.getElementById('roomsInput').value = document.getElementById('rooms').value;
		document.getElementById('childrenInput').value = document.getElementById('children').value;
		document.getElementById('adultInput').value = document.getElementById('adults').value;
		document.getElementById('promoInput').value = document.getElementById('promo').value;
	})

	document.getElementsByClassName('js-booking-close')[0].addEventListener('click', function(){
		document.getElementsByClassName('booking-container')[0].classList.remove('open')
	})
	document.getElementsByClassName('js-booking-cta')[0].addEventListener('click', function(){
		document.getElementsByClassName('booking-container')[0].classList.add('open')
	})


	$(document).ready(function () {
		
		//booking datepicker
		//To create after event 
		$.datepicker._updateDatepicker_original = $.datepicker._updateDatepicker;
		$.datepicker._updateDatepicker = function (inst) {
			$.datepicker._updateDatepicker_original(inst);
			var afterShow = this._get(inst, 'afterShow');
			if (afterShow)
				afterShow.apply((inst.input ? inst.input[0] : null));  // trigger custom callback
		}
		setUpBooking();
		

		
		
	});

	document.getElementById('fullDates').addEventListener('change', function(){
		let thisValue = this.value.split('/');
		document.getElementById('arriveInput').value = thisValue[0]
		document.getElementById('departureInput').value = thisValue[1]

		start = thisValue[0];
		end = thisValue[1];
		$('#calendarContainer').datepicker( 'destroy' );
		setUpBooking();
		
	})

	

	window.onload = function() {
		if(document.getElementById('home')){
			scrollW();
			window.addEventListener('scroll', function(){
				scrollW();
			})
		} else {
			document.getElementById('header').classList.add('top');
			document.getElementById('menuSide').classList.add('top');
		}
		resizeWindow();
		window.addEventListener('resize', function(){
			resizeWindow();
		});

		//nav
		let allLinksNav = document.getElementById('primary-nav').getElementsByTagName('a');
		for(let j=0; j < allLinksNav.length; j++){
			//click
			allLinksNav[j].addEventListener('click', function(e){
				if(this.nextElementSibling.classList.contains('submenu')){
					e.preventDefault();
					if(this.nextElementSibling.classList.contains('open')){
						this.nextElementSibling.classList.remove('open')
						this.nextElementSibling.style.height = '0';
					} else {
						openSubNav(this);
					}
				}
			})
			
		}
	};

	// change kms to miles attraction tpl
	
	// // let kmsText = document.querySelector('.attraction__info .additional-info');
	// let btns = document.querySelectorAll('.attractions-content .attractions-wrapper .attraction__wrapper .attraction__info .learn-more-btn')
	// let btnsArray = [...btns];
	// // console.log(kmsText);
	// console.log(btnsArray);

	// btnsArray.forEach(btn => {
	// 	console.log(btn);
	// 	btn.addEventListener('click', function() {
	// 		console.log('Se hizo clic en el botón');
	// 	});
	// });

	

}());
function parallaxRotation(el){
	let id_elem = el.getAttribute('target-id');
	let element_rotation = parseInt(el.getAttribute('parallax-rotation'));
	let lastS = window.pageYOffset || document.documentElement.scrollTop;

	let parallaxFunction = function(){
		let scrolling = window.pageYOffset || document.documentElement.scrollTop;
		if(scrolling > lastS){
			element_rotation = element_rotation + 1;
		} else {
			element_rotation = element_rotation - 1;
		}
		
		lastS = scrolling;
		el.setAttribute('parallax-rotation', element_rotation)
		el.getElementsByClassName('element')[0].setAttribute('style','transform:rotate('+element_rotation +'deg)')
	}

	scrollParallax[id_elem] = parallaxFunction
	window.addEventListener('scroll', scrollParallax[id_elem])	
}

function setUpBooking() {
	

	$('#calendarContainer').datepicker({
		changeMonth: false,
		minDate:0,
		dateFormat: 'mm-dd-yy',
		numberOfMonths: 2,
		beforeShowDay: function (date) {
			$.datepicker._defaults.dateFormat = "mm-dd-yy";
			var startDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, start);
			var endDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, end);
			if (date.getTime() == startDate.getTime()) {
				return [true, "startday"];
			} else {
				if (date.getTime() == endDate.getTime()) {
					return [true, "endday"];
				} else {
					if (date.getTime() > startDate.getTime() && date.getTime() < endDate.getTime()) {
						return [true, "days"];
					} else {
						return [true, ""];
					}
				}
			}
		},
		onSelect: function (date) {
			var arrive = $.datepicker.parseDate($.datepicker._defaults.dateFormat, start);
			var departure = $.datepicker.parseDate($.datepicker._defaults.dateFormat, end);
			var selectedDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, date);

			if (opened == 0) {
				opened = 1;
				start = date;
				end = date;
				//opencheck = 0;
			} else {
				opened = 0;
				if (selectedDate <= arrive) {
					end = start;
					start = date;
				} else {
					end = date;
				}
			}

			$('#arriveInput').attr('value',start);
			$('#departureInput').attr('value',end);
			$('#fullDates').attr('value',start +'/'+end);
		
		}
	});
}

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if(!document.getElementById('header').classList.contains('top')){
			document.getElementById('header').classList.add('top');
			document.getElementById('menuSide').classList.add('top');
		}
	} else {
		if(document.getElementById('header').classList.contains('top')){
			document.getElementById('header').classList.remove('top');
			document.getElementById('menuSide').classList.remove('top');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}
function resizeWindow(){
	//calculate a new window size
	windowWidth = w.innerWidth||e.clientWidth||g.clientWidth;
	windowHeight = w.innerHeight||e.clientHeight||g.clientHeight;

	//header image to be window height on homepage
	if(document.getElementsByClassName('big-image').length > 0){
		
		let headerImages = document.getElementsByClassName('big-image');
		let headerImagesLength = headerImages.length;
		for(let i = 0; i < headerImagesLength; i++){
			headerImages[i].style.height = (windowHeight + 5) + 'px';
			
		}
		
	}
}
function addNumber(field){
	let addinputValue = parseInt(field.getElementsByTagName('input')[0].value);
	
	if(addinputValue < 5){
		addinputValue++;
		field.getElementsByTagName('input')[0].value = addinputValue;
	}
	
}
function removeNumber(field){
	let removeinputValue = parseInt(field.getElementsByTagName('input')[0].value);
	
	if(removeinputValue > 0){
		removeinputValue--;
		field.getElementsByTagName('input')[0].value = removeinputValue
	}
}